import { useDispatch, useSelector } from "react-redux"

import { setCloseSnackbar } from "actions"

const useSnackBar = () => {
  const dispatch = useDispatch()
  return {
    snackbar: useSelector((state) => state.snackbar),
    closeSnackbar: () => dispatch(setCloseSnackbar()),
  }
}

export default useSnackBar
